import { DocumentsTableFeature } from 'features/DocumentsTableFeature';
import { FileExtension } from 'types/file';

export const DocumentsSection = () => (
  <DocumentsTableFeature
    fileExtensions={[FileExtension.pdf, FileExtension.csv, FileExtension.png]}
    maxDocumentCount={10}
    name="files"
    titleVariant="subtitle"
  />
);
